import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import PropTypes from 'prop-types';

const baseClass =
  'inline-flex items-center justify-center font-epilogue font-semibold focus:outline-none disabled:cursor-not-allowed bg-[length:300%_100%] bg-left transition-[background-position] duration-300 ease-in-out';

const variantStyles = {
  primary:
    'bg-gradient-to-r from-white from-[33.33%] to-[66.66%] to-[rgba(0,0,0,.1)] text-new-teal-9 border border-white hover:bg-right px-5 py-3.5 text-base lg:text-lg',

  secondary:
    'bg-gradient-to-r from-new-dark-90 from-[33.33%] to-[66.66%] to-new-dark-60 text-white border border-new-dark-90 hover:bg-right px-5 py-3.5 text-base lg:text-lg',

  'outline-white':
    'bg-gradient-to-r from-transparent from-[33.33%] to-[66.66%] to-new-dark-30 text-white border border-white hover:bg-right px-5 py-3.5 text-base lg:text-lg',

  'outline-black':
    'bg-gradient-to-r from-transparent from-[33.33%] to-[66.66%] to-[rgba(0,0,0,.1)] text-new-dark-90 border border-new-dark-90 hover:bg-right px-5 py-3.5 text-base lg:text-lg',

  'link-white': 'text-white text-sm underline underline-offset-4 hover:bg-new-dark-75',

  'link-black': 'text-new-dark-75 text-sm underline underline-offset-4 hover:bg-new-green-30',
};

const Button = forwardRef(function Button(
  { as: Component = 'button', variant = 'primary', className = '', children, ...props },
  ref,
) {
  const classes = twMerge(baseClass, variantStyles[variant] ?? variantStyles.primary, className);

  return (
    <Component ref={ref} className={classes} {...props}>
      {children}
    </Component>
  );
});

Button.displayName = 'Button';

Button.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(Object.keys(variantStyles)),
  className: PropTypes.string,
};

export default Button;
